import EditableItemList from "../../../../../components/editableItemList/EditableItemList";
import { IDeliveryItem } from "../../../../../models/deliveryItem";
import DeliveryItemListItem from "./DeliveryItemListItem";

interface DeliveryItemListProps {
  items: IDeliveryItem[];
  onAdd: () => void;
  onEdit: (item: IDeliveryItem) => void;
  onDelete: (id: string) => void;
}

const DeliveryItemList = (props: DeliveryItemListProps) => {
  const { items, onAdd, onEdit, onDelete } = props;

  return (
    <EditableItemList listCount={items.length} onAdd={onAdd}>
      {items.map((item) => (
        <DeliveryItemListItem
          key={item.id}
          deliveryItem={item}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ))}
    </EditableItemList>
  );
};

export default DeliveryItemList;
